import { render } from "./AddonCollections.vue?vue&type=template&id=5b6d8aca&scoped=true"
import script from "./AddonCollections.vue?vue&type=script&lang=js"
export * from "./AddonCollections.vue?vue&type=script&lang=js"

import "./AddonCollections.vue?vue&type=style&index=0&id=5b6d8aca&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6d8aca"]])

export default __exports__